import { nodePath } from 'Config/path.js';
import { fetchGet } from 'Services/fetchService.js';
import { IDescriptionResponse, IDescriptionRequest } from 'CommonTypes/OutboxMessages/OutboxMessages';

export default async ({ outboxId }: IDescriptionRequest) => {
    const response: IDescriptionResponse = await fetchGet(`${nodePath}/outbox-messages/${outboxId}/description`);

    return response;
};
